var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { staticClass: "px-2 background" },
        [
          _c(
            "v-dialog",
            {
              attrs: {
                width: "990",
                persistent: "",
                "no-click-animation": "",
                scrollable: "",
              },
              model: {
                value: _vm.dialog,
                callback: function ($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog",
              },
            },
            [
              _c(
                "v-card",
                {
                  staticClass: "pa-0",
                  attrs: { "max-height": "calc(100vh - 200px)" },
                },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { color: "transparent", flat: "", height: "46" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-700--text font-weight-bold",
                        },
                        [
                          _vm._v(
                            "Información del lote " + _vm._s(_vm.item?.batch_id)
                          ),
                        ]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        { staticClass: "mr-4" },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-n1",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit("close")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    { staticClass: "pa-0 pb-5" },
                    [
                      _c("v-divider"),
                      _c(
                        "v-expansion-panels",
                        {
                          staticClass: "mt-5",
                          model: {
                            value: _vm.panelDocumentType,
                            callback: function ($$v) {
                              _vm.panelDocumentType = $$v
                            },
                            expression: "panelDocumentType",
                          },
                        },
                        [
                          _c(
                            "v-expansion-panel",
                            [
                              _c(
                                "v-expansion-panel-header",
                                { staticClass: "px-5 py-3" },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      attrs: {
                                        "no-gutters": "",
                                        align: "center",
                                        justify: "space-between",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "subtitle-2 grey-700--text font-weight-bold d-flex align-center",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                size: "16",
                                                left: "",
                                                color: "grey-700",
                                              },
                                            },
                                            [_vm._v("mdi-file")]
                                          ),
                                          _vm._v("Tipos de documentos"),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-expansion-panel-content",
                                { staticClass: "px-2" },
                                [
                                  !_vm.documentTypesList?.length
                                    ? _c("v-empty-state", {
                                        staticClass: "mt-n2 pb-2",
                                        attrs: {
                                          type: "documents",
                                          id: "documentos",
                                          customClass: "mt-0",
                                          "min-height": "199",
                                          isFree: true,
                                          title: "No hay documentos",
                                          height: 199,
                                        },
                                      })
                                    : _c("v-simple-table", {
                                        staticClass:
                                          "px-0 no-hover table-not-rounded",
                                        attrs: { dense: "" },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function () {
                                              return [
                                                _c("thead", [
                                                  _c("tr", [
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-left grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          "min-width": "130px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Tipo de documento"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right grey-700--text font-weight-medium",
                                                      },
                                                      [_vm._v("Total")]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right grey-700--text font-weight-medium",
                                                      },
                                                      [_vm._v("Neto")]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right grey-700--text font-weight-medium",
                                                      },
                                                      [_vm._v("Iva")]
                                                    ),
                                                  ]),
                                                ]),
                                                _c(
                                                  "tbody",
                                                  _vm._l(
                                                    _vm.documentTypesList,
                                                    function (doc, i) {
                                                      return _c(
                                                        "tr",
                                                        { key: i },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "body-2",
                                                            },
                                                            [
                                                              doc.type
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      class: [
                                                                        "d-inline-block text-truncate",
                                                                        {
                                                                          "font-weight-bold":
                                                                            doc.type ===
                                                                            "Total",
                                                                        },
                                                                      ],
                                                                      staticStyle:
                                                                        {
                                                                          "max-width":
                                                                            "99%",
                                                                        },
                                                                    },
                                                                    [
                                                                      doc.type ===
                                                                      "Total"
                                                                        ? [
                                                                            _vm._v(
                                                                              "Total"
                                                                            ),
                                                                          ]
                                                                        : [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm._f(
                                                                                  "nameDocumentsType"
                                                                                )(
                                                                                  doc.type
                                                                                )
                                                                              )
                                                                            ),
                                                                          ],
                                                                    ],
                                                                    2
                                                                  )
                                                                : _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "body-2 text--disabled font-italic",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Sin especificar"
                                                                      ),
                                                                    ]
                                                                  ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-right body-2",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  class: [
                                                                    {
                                                                      "font-weight-bold":
                                                                        doc.type ===
                                                                        "Total",
                                                                    },
                                                                  ],
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$fmt.currency(
                                                                        _vm.batchCurrency,
                                                                        doc.total
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-right body-2",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  class: [
                                                                    {
                                                                      "font-weight-bold":
                                                                        doc.type ===
                                                                        "Total",
                                                                    },
                                                                  ],
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$fmt.currency(
                                                                        _vm.batchCurrency,
                                                                        doc.net
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-right body-2",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  class: [
                                                                    {
                                                                      "font-weight-bold":
                                                                        doc.type ===
                                                                        "Total",
                                                                    },
                                                                  ],
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$fmt.currency(
                                                                        _vm.batchCurrency,
                                                                        doc.vat
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                      }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-expansion-panels",
                        {
                          staticClass: "mt-5",
                          model: {
                            value: _vm.panelSendAngency,
                            callback: function ($$v) {
                              _vm.panelSendAngency = $$v
                            },
                            expression: "panelSendAngency",
                          },
                        },
                        [
                          _c(
                            "v-expansion-panel",
                            [
                              _c(
                                "v-expansion-panel-header",
                                { staticClass: "px-5 py-3" },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      attrs: {
                                        "no-gutters": "",
                                        align: "center",
                                        justify: "space-between",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "subtitle-2 grey-700--text font-weight-bold d-flex align-center",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                size: "16",
                                                left: "",
                                                color: "grey-700",
                                              },
                                            },
                                            [_vm._v("mdi-bank")]
                                          ),
                                          _vm._v(
                                            "Envio al " +
                                              _vm._s(_vm.$t("generals.SII"))
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-expansion-panel-content",
                                { staticClass: "px-2" },
                                [
                                  !_vm.sentAgencyList?.length
                                    ? _c("v-empty-state", {
                                        staticClass: "mt-n2 pb-2",
                                        attrs: {
                                          type: "documents",
                                          id: "documentos",
                                          customClass: "mt-0",
                                          isFree: true,
                                          title: "No hay documentos",
                                          height: 139,
                                          minHeight: "230px",
                                        },
                                      })
                                    : _c("v-simple-table", {
                                        staticClass:
                                          "px-0 no-hover table-not-rounded",
                                        attrs: { dense: "" },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function () {
                                              return [
                                                _c("thead", [
                                                  _c("tr", [
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-left grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          width: "200px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Tipo de documento"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          width: "120px",
                                                        },
                                                      },
                                                      [_vm._v("Por confirmar")]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          width: "100px",
                                                        },
                                                      },
                                                      [_vm._v("Por enviar")]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          width: "100px",
                                                        },
                                                      },
                                                      [_vm._v("Enviado")]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          width: "100px",
                                                        },
                                                      },
                                                      [_vm._v("Pendiente")]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          width: "100px",
                                                        },
                                                      },
                                                      [_vm._v("Aprobado")]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          width: "100px",
                                                        },
                                                      },
                                                      [_vm._v("Rechazado")]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          width: "100px",
                                                        },
                                                      },
                                                      [_vm._v("Total")]
                                                    ),
                                                  ]),
                                                ]),
                                                _c(
                                                  "tbody",
                                                  [
                                                    _vm._l(
                                                      _vm.sentAgencyList,
                                                      function (doc, j) {
                                                        return _c(
                                                          "tr",
                                                          { key: j },
                                                          [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "body-2",
                                                              },
                                                              [
                                                                doc.type
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "d-inline-block text-truncate",
                                                                        staticStyle:
                                                                          {
                                                                            "max-width":
                                                                              "99%",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm._f(
                                                                                "nameDocumentsType"
                                                                              )(
                                                                                doc.type
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "body-2 text--disabled font-italic",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Sin especificar"
                                                                        ),
                                                                      ]
                                                                    ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-right body-2",
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$fmt.integer(
                                                                        doc.toConfirm
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-right body-2",
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$fmt.integer(
                                                                        doc.toSend
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-right body-2",
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$fmt.integer(
                                                                        doc.sent
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-right body-2",
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$fmt.integer(
                                                                        doc.pending
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-right body-2",
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$fmt.integer(
                                                                        doc.approved
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-right body-2",
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$fmt.integer(
                                                                        doc.rejected
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-right body-2",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "font-weight-bold",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$fmt.integer(
                                                                          doc.totalCol
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    _c("tr", [
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-left body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [_vm._v("Total")]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$fmt.integer(
                                                                    _vm
                                                                      .totalSentAgencyList
                                                                      .toConfirm
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$fmt.integer(
                                                                    _vm
                                                                      .totalSentAgencyList
                                                                      .toSend
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$fmt.integer(
                                                                    _vm
                                                                      .totalSentAgencyList
                                                                      .sent
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$fmt.integer(
                                                                    _vm
                                                                      .totalSentAgencyList
                                                                      .pending
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$fmt.integer(
                                                                    _vm
                                                                      .totalSentAgencyList
                                                                      .approved
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$fmt.integer(
                                                                    _vm
                                                                      .totalSentAgencyList
                                                                      .rejected
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$fmt.integer(
                                                                    _vm
                                                                      .totalSentAgencyList
                                                                      .total
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                    _c("tr", [
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-left body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Porcentajes"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .percentageSentAgencyList
                                                                    .toConfirm
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .percentageSentAgencyList
                                                                    .toSend
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .percentageSentAgencyList
                                                                    .sent
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .percentageSentAgencyList
                                                                    .pending
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .percentageSentAgencyList
                                                                    .approved
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .percentageSentAgencyList
                                                                    .rejected
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .percentageSentAgencyList
                                                                    .total
                                                                ) + "%"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                      }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-expansion-panels",
                        {
                          staticClass: "mt-5",
                          model: {
                            value: _vm.panelDistribution,
                            callback: function ($$v) {
                              _vm.panelDistribution = $$v
                            },
                            expression: "panelDistribution",
                          },
                        },
                        [
                          _c(
                            "v-expansion-panel",
                            [
                              _c(
                                "v-expansion-panel-header",
                                { staticClass: "px-5 py-3" },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      attrs: {
                                        "no-gutters": "",
                                        align: "center",
                                        justify: "space-between",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "subtitle-2 grey-700--text font-weight-bold d-flex align-center",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                size: "16",
                                                left: "",
                                                color: "grey-700",
                                              },
                                            },
                                            [_vm._v("mdi-file-move")]
                                          ),
                                          _vm._v("Distribución"),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-expansion-panel-content",
                                { staticClass: "px-2" },
                                [
                                  !_vm.distributionList?.length
                                    ? _c("v-empty-state", {
                                        staticClass: "mt-n2 pb-2",
                                        attrs: {
                                          type: "documents",
                                          id: "documentos",
                                          customClass: "mt-0",
                                          isFree: true,
                                          title: "No hay documentos",
                                          height: 139,
                                          minHeight: "230px",
                                        },
                                      })
                                    : _c("v-simple-table", {
                                        staticClass:
                                          "px-0 no-hover table-not-rounded",
                                        attrs: { dense: "" },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function () {
                                              return [
                                                _c("thead", [
                                                  _c("tr", [
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-left grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          width: "200px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Tipo de documento"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          width: "100px",
                                                        },
                                                      },
                                                      [_vm._v("Pendiente")]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          width: "100px",
                                                        },
                                                      },
                                                      [_vm._v("Enviado")]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          width: "100px",
                                                        },
                                                      },
                                                      [_vm._v("No enviado")]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          width: "100px",
                                                        },
                                                      },
                                                      [_vm._v("Total")]
                                                    ),
                                                  ]),
                                                ]),
                                                _c(
                                                  "tbody",
                                                  [
                                                    _vm._l(
                                                      _vm.distributionList,
                                                      function (doc, k) {
                                                        return _c(
                                                          "tr",
                                                          { key: k },
                                                          [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "body-2",
                                                              },
                                                              [
                                                                doc.type
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "d-inline-block text-truncate",
                                                                        staticStyle:
                                                                          {
                                                                            "max-width":
                                                                              "99%",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm._f(
                                                                                "nameDocumentsType"
                                                                              )(
                                                                                doc.type
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "body-2 text--disabled font-italic",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Sin especificar"
                                                                        ),
                                                                      ]
                                                                    ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-right body-2",
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$fmt.integer(
                                                                        doc.pending
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-right body-2",
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$fmt.integer(
                                                                        doc.sent
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-right body-2",
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$fmt.integer(
                                                                        doc.notSent
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-right body-2",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "font-weight-bold",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$fmt.integer(
                                                                          doc.totalCol
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    _c("tr", [
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-left body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [_vm._v("Total")]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$fmt.integer(
                                                                    _vm
                                                                      .totalDistributionList
                                                                      .pending
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$fmt.integer(
                                                                    _vm
                                                                      .totalDistributionList
                                                                      .sent
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$fmt.integer(
                                                                    _vm
                                                                      .totalDistributionList
                                                                      .notSent
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$fmt.integer(
                                                                    _vm
                                                                      .totalDistributionList
                                                                      .total
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                    _c("tr", [
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-left body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Porcentajes"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .percentageDistributionList
                                                                    .pending
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .percentageDistributionList
                                                                    .sent
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .percentageDistributionList
                                                                    .notSent
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-right body-2",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .percentageDistributionList
                                                                    .total
                                                                ) + "%"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                      }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }